// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1gkWv","gfeWrapper":"CalendarEvent_gfeWrapper__3g5EJ"};